import { ViewContainerRef, Injectable, Type, ComponentRef, Component } from '@angular/core';
import { REGISTRY } from '../interfaces/registry-services';
import { EditFormComponent } from '../forms/formview/editform.component';
import { AmazonSchemaCreatorComponent } from '../forms/produtos/amazon/amazon-schema-creator/amazon-schema-creator.component';
import { AmazonSearchCategoryComponent } from '../forms/produtos/amazon/amazon-search-category/amazon-search-category.component';
import { CriacaoProdutoFormComponent } from '../forms/produtos/amazon/criacao-produto/criacao-produto-form/criacao-produto-form.component';
import { B2wAttributeVarComponent } from '../forms/produtos/b2w/b2w-attribute/b2w-attribute-var.component';
import { B2wAttributeComponent } from '../forms/produtos/b2w/b2w-attribute/b2w-attribute.component';
import { B2wCategoryComponent } from '../forms/produtos/b2w/b2w-category/b2w-category.component';
import { CarrefourCategoryComponent } from '../forms/produtos/carrefour/carrefour-category/carrefour-category.component';
import { LiveloSearchCategoryComponent } from '../forms/produtos/livelo/livelo-category/livelo-category.component';
import { MeliNewWizardComponent } from '../forms/produtos/meli/meli-new-wizard/meli-new-wizard.component';
import { MeliCategoryFinderComponent } from '../forms/produtos/mercadolivre/meli-category-finder/meli-category-finder.component';
import { MeliEditFormComponent } from '../forms/produtos/mercadolivre/meli-edit-form/meli-edit-form.component';
import { MeliItemAttribComponent } from '../forms/produtos/mercadolivre/meli-item-attrib/meli-item-attrib.component';
import { MeliItemGarantiaComponent } from '../forms/produtos/mercadolivre/meli-item-garantia/meli-item-garantia.component';
import { MeliItemVariationAttribComponent } from '../forms/produtos/mercadolivre/meli-item-variation-attrib/meli-item-variation-attrib.component';
import { ShopeeAttributeComponent } from '../forms/produtos/shopee/shopee-attribute/shopee-attribute.component';
import { ShopeeCategoryComponent } from '../forms/produtos/shopee/shopee-category/shopee-category.component';
import { ShopeeVarNewComponent } from '../forms/produtos/shopee/shopee-var-new/shopee-var-new.component';
import { ShopeeVarTierComponent } from '../forms/produtos/shopee/shopee-var-tier/shopee-var-tier.component';
import { ShopeeVarComponent } from '../forms/produtos/shopee/shopee-var/shopee-var.component';
import { ViaVarejoAttributeComponent } from '../forms/produtos/viavarejo/viavarejo-attribute/viavarejo-attribute.component';
import { ViaVarejoCategoryComponent } from '../forms/produtos/viavarejo/viavarejo-category/viavarejo-category.component';
import { QueryExecutorComponent } from '../forms/query-executor/query-executor.component';
import { ScreenRecorderComponent } from '../screen-recorder/screen-recorder.component';
import { ActionButtonGenericComponent } from '../system-utils/action-button-generic/action-button-generic.component';
import { LogIntegracaoItemComponent } from '../system-utils/log-integracao-item/log-integracao-item.component';
import { MainDashboardComponent } from '../system-view/main-dashboard/main-dashboard.component';
import { CorreiosServices } from './correios.services';
import { FileLoaderServices } from './FileLoader.services';
import { MeliServices } from './meli.service';
import { RefreshPreferencesServices } from './RefreshPreferences.service';
import { ShopeeServices } from './shopee.service';
import { CronFormComponent } from '../forms/cron-form/cron-form.component';
import { WebhookEditComponent } from '../webhook-creator/webhook-creator/webhook-edit/webhook-edit.component';
import { CodeEditorComponent } from '../system-utils/code-editor/code-editor.component';
import { FormulaTSService } from './formula-ts.service';
import { WorkFlowActionOutputParameter } from '../webhook-creator/webhook-creator/webhook-interfaces/configuration';
import { Variable } from '../forms/formula-tester/formula-tester.component';
import { FormGroup } from '@angular/forms';
import { MeliCategoryPredictorComponent } from '../forms/produtos/mercadolivre/meli-edit-form/meli-category-predictor/meli-category-predictor.component';
import { TiktokAttributeComponent } from '../forms/produtos/tiktok/tiktok-attribute/tiktok-attribute.component';
import { TiktokAttributeVarComponent } from '../forms/produtos/tiktok/tiktok-attribute/tiktok-attribute-var.component';
import { TiktokBrandComponent } from '../forms/produtos/tiktok/tiktok-brand/tiktok-brand.component';
import { TiktokCategoryComponent } from '../forms/produtos/tiktok/tiktok-category/tiktok-category.component';
import { GenericLogComponent } from '../forms/generic-log/generic-log.component';

@Injectable({ providedIn: 'any' })
export class DynamicLoaderService {
  
  
  constructor(private fts:FormulaTSService) {
    
        REGISTRY.set("RefreshPreferencesServices", RefreshPreferencesServices);
        REGISTRY.set("MeliServices", MeliServices);
        REGISTRY.set("ShopeeCategoryComponent", ShopeeCategoryComponent);
        REGISTRY.set("ShopeeServices", ShopeeServices);
        REGISTRY.set("ShopeeVarComponent", ShopeeVarComponent);
        REGISTRY.set("ShopeeVarNewComponent", ShopeeVarNewComponent);
        REGISTRY.set("ActionButtonGenericComponent", ActionButtonGenericComponent);
        REGISTRY.set("CorreiosServices", CorreiosServices);
        REGISTRY.set("ViaVarejoCategoryComponent",ViaVarejoCategoryComponent);
        REGISTRY.set("ViaVarejoAttributeComponent",ViaVarejoAttributeComponent);
        REGISTRY.set("CarrefourCategoryComponent",CarrefourCategoryComponent);
        REGISTRY.set("FormViewComponent",EditFormComponent);
        REGISTRY.set("MeliEditFormComponent",MeliEditFormComponent);
        REGISTRY.set("CriacaoProdutoFormComponent",CriacaoProdutoFormComponent);
        REGISTRY.set("MeliNewWizardComponent",MeliNewWizardComponent);
        REGISTRY.set("MeliItemVariationAttribComponent",MeliItemVariationAttribComponent);
        REGISTRY.set("MeliItemGarantiaComponent",MeliItemGarantiaComponent);
        REGISTRY.set("MeliItemAttribComponent",MeliItemAttribComponent);
        REGISTRY.set("MeliCategoryFinderComponent",MeliCategoryFinderComponent);
        REGISTRY.set("AmazonSchemaCreatorComponent",AmazonSchemaCreatorComponent);
        REGISTRY.set("ShopeeVarTierComponent",ShopeeVarTierComponent);
        REGISTRY.set("ShopeeAttributeComponent",ShopeeAttributeComponent);
        REGISTRY.set("AmazonSearchCategoryComponent",AmazonSearchCategoryComponent);
        REGISTRY.set("LiveloSearchCategoryComponent",LiveloSearchCategoryComponent);
        REGISTRY.set("MainDashboardComponent",MainDashboardComponent);
        REGISTRY.set("ScreenRecorderComponent",ScreenRecorderComponent);
        REGISTRY.set('LogIntegracaoItemComponent',LogIntegracaoItemComponent);
        REGISTRY.set("FileLoaderServices",FileLoaderServices);
        REGISTRY.set("B2wAttributeComponent",B2wAttributeComponent);
        REGISTRY.set("B2wAttributeVarComponent",B2wAttributeVarComponent);
        REGISTRY.set("B2wCategoryComponent",B2wCategoryComponent);
        REGISTRY.set("QueryExecutorComponent",QueryExecutorComponent);
        REGISTRY.set("CronFormComponent",CronFormComponent);
        REGISTRY.set("WebhookEditComponent",WebhookEditComponent);
        REGISTRY.set("CodeEditorComponent",CodeEditorComponent);
        REGISTRY.set("MeliCategoryPredictorComponent",MeliCategoryPredictorComponent);
        REGISTRY.set("TiktokAttributeComponent",TiktokAttributeComponent);
        REGISTRY.set("TiktokAttributeVarComponent",TiktokAttributeVarComponent);
        REGISTRY.set("TiktokBrandComponent",TiktokBrandComponent);
        REGISTRY.set("TiktokCategoryComponent",TiktokCategoryComponent);
        REGISTRY.set("GenericLogComponent", GenericLogComponent);
  }

  loadParameter(component:ComponentRef<any>, parameters:object):void {
    Object.keys(parameters).forEach(key => {
      
      if (component.hasOwnProperty(key)) {
        component[key] = parameters[key];
      }
    });
  }

  loadOutput(
      component:ComponentRef<any>, 
      outPutEvent:WorkFlowActionOutputParameter[], 
      map:Map<string,any>,
      rootForm:FormGroup,
      context:any) {

      if ( outPutEvent!= null  ){
        for ( var output of outPutEvent ){
          if (outPutEvent== null || output.eventName == null || output.function == null) {
            continue;
          }

          if (component.hasOwnProperty(output.eventName)) {
              component[output.eventName].subscribe(value=>{
                  this.fts.toMap(value,map);
                  this.fts.execute(output.function.toString(),map, rootForm,context);
              });
          }
        }
      }
  }

  getComponent(componentName:string){
    return REGISTRY.get(componentName);
  }
  
}